const requireContext = require.context('./', true, /^(?!\.\/index).*\.js$/)
const i18n = requireContext.keys().reduce((pre, current) => Object.assign(pre, requireContext(current).default), {})

const index = {
    common: {
        title: 'HZNet远程监控平台',
        subTitle: {
            hydro: '水电云',
            power: '用电云',
            photo: '光伏云'
        },
        operator: {
            operator: '操作',
            search: '查询',
            export: '导出',
            add: '新增',
            edit: '修改',
            delete: '删除',
            save: '保存',
            cancel: '取消',
            deleteConfirm: '确定要删除',
            deleteSuccess: '删除成功！',
            deleteFail: '删除失败！',
            addSuccess: '添加成功！',
            editSuccess: '修改成功！',
            operatorFail: '操作失败！',
            saveSuccess: '保存成功！',
            yes: '是',
            no: '否'
        },
        tips: {
            condition: '搜索条件不能超过16个字符'
        },
        name: {
            startTime: '开始时间',
            endTime: '结束时间',
            time: '时间',
            confirmInfo: '确认信息',
        }
    },
    //登录页
    login: {
        name: '登    录',
        downloadAndroidApp: '下载安卓APP',
        message: {
            enterUser: '请输入用户名！',
            enterPwd: '请输入密码！',
            enterCode: '请输入验证码',
            userPwdError: '用户名密码错误！',
            codeError: '验证码错误'
        }
    },
    //布局
    layout: {
        home: '首页',
        personSetting: '个人设置',
        exit: '退出',
        close: '关闭',
        closeOther: '关闭其他',
        closeAll: '关闭全部'
    },
    //个人信息
    personal: {
        account: '账号',
        name: '姓名',
        phone: '电话',
        email: '邮箱',
        oldPwd: '原始密码',
        pwd: '密码',
        confirmPwd: '确认密码',
        confirm: '确定',
        bandWx: '绑定微信',
        formatPwd: '密码不能为空',
        formatPwd1: '密码与确认密码不一致',
        formatAccount: '请输入账号',
        formatName: '请输入姓名',
        formatLength: '长度2~32',
        formatPhone: '请输入正常的电话格式',
        formatPwd2: '6-20位，由字母(区分大小写)、数字组成，可包含特殊字符',
        formatEmail: '邮箱格式错误',
        editSuccess: '修改成功！',
        accountNoExist: '账号不存在！',
        oldPwdError: '原始密码不正确',
        accountEditError: '账号修改失败！'
    },
    //系统管理
    system: {
        user: {
            placeholder: '请输入账号/姓名...',
            account: '账号',
            name: '姓名',
            phone: '电话',
            email: '邮箱',
            registerTime: '注册时间',
            lastLoginTime: '最后登录时间',
            pwd: '密码',
            confirmPwd: '确认密码',
            roleDistribution: '角色分配',
            station: '站点管理',
            enterPwd: '请输入密码',
            enterConfirmPwd: '请输入确认密码',
            pwdError: '密码与确认密码不一致',
            enterAccount: '请输入账号',
            length: '长度2~16',
            enterName: '请输入姓名',
            formatPhone: '请输入正常的电话格式',
            formatPwd: '6-20位，由字母(区分大小写)、数字组成，可包含特殊字符',
            formatEmail: '邮箱格式错误',
            formatLength: '长度不能超过32位',
            entRole: '请选择角色',
            condition16: '搜索条件不能超过16个字符',
            addUser: '新建用户',
            userEdit: '用户编辑',
            userExist: '用户名存在，请重新输入！'
        },
        role: {
            name: '名称',
            role: '角色',
            user: '用户',
            addRole: '新增角色',
            addSuccess: '角色{newrole}新增成功',
            addExist: '角色{newrole}已经存在',
            addFail: '角色{newrole}新增失败',
            permissionSuccess: '权限{RoleName}的用户分配成功',
            permissionFail: '权限{RoleName}的用户分配失败'
        },
        siteM: {
            name: '名称',
            group: '站点组',
            site: '站点',
            addSite: '新增站点组',
            deleteFail: '站点组{name}删除失败(请先删除子权限)',
            deleteFail1: '站点组{name}删除失败',
            enterSiteGroup: '请输入站点组名',
            length: '长度2~16',
            selectSiteGroup: '请选择一个站点组',
            addSuccess: '站点组{newGroup}新增成功',
            addExist: '站点组{newGroup}已经存在',
            addFail: '站点组{newGroup}新增失败',
            clearConfirm: '确定要清空站点组{name}的站点吗',
            distributionSuccess: '站点组{name}的站点分配成功',
            distributionFail: '站点组{name}的站点分配失败',
        },
        setting: {
            file: '文件',
            allSelect: '全选',
            unSelect: '反选',
            menu: '菜单',
            selectFile: "请选择文件！",
            selectMenu: '请选择菜单！'
        },
        siteS: {
            placeholder: '请输入站点名/编号...',
            siteName: '站点名称',
            siteCode: '站点编号',
            latlng: '经纬度', 
            remark: '备注',
            siteType: '站点类型',
            siteLat: '站点纬度',
            siteLng: '站点经度',
            expireTime: '过期时间',
            svnAddress: 'svn地址',
            allowControl: '允许控制',
            remark: '备注',
            imgUpload: '图片上传',
            getLagLng: '获取经纬度',
            selectFile: '选取文件',
            uploadDesc: '支持jpg、jpeg、png格式，大小不超过2.0M',
            placeholder_name: '请输入站点名称',
            placeholder_type: '请选择站点类型',
            placeholder_code: '请输入站点编号',
            placeholder_lng: '请输入站点经度',
            placeholder_lat: '请输入站点纬度',
            placeholder_svn: '请输入svn地址',
            placeholder_expireTime: '请选择过期时间',
            placeholder_remark: '请输入备注',
            formatLng: '经度格式不正确',
            formatLng1: '请输入站点经度',
            formatLat: '纬度格式不正确',
            formatLat1: '请输入站点纬度',
            formatName: '请输入名称',
            formatLength: '长度2~16',
            formatType: '请选择站点类型',
            formatCode: '请输入站点编号',
            formatCode1: '站点编号为数字',
            formatCode2: '长度不能超过16位',
            formatRemark: '长度不能超过250',
            formatUpload: '文件大小不能大于2M,请重新选择',
            addUser: '新建用户',
            siteEdit: '站点编辑'
        },
        menu: {
           name: '名称' ,
           parentMenu: '父菜单',
           systemSign: '系统标识',
           link: '链接',
           isShow: '是否显示',
           icon: '图标',
           menuType: '菜单类型',
           outerLink: '外部链接',
           template: '模板',
           sort: '排序',
           placeholder_name: '请输入名称',
           placeholder_icon: '请输入图标',
           placeholder_systemSign: '请选择系统标识',
           placeholder_parentMenu: '请选择父菜单',
           placeholder_link: '请输入链接',
           placeholder_outerLink: '请输入外部链接',
           placeholder_sort: '请输入排序',
           placeholder_template: '请选择模板',
           formatNum: '请输入100以内数字',
           formatName: '请输入名称',
           formatLength: '长度2~16',
           formatSort: '请排序',
           formatLength1: '长度不能超过200个字符',
           addMenu: '新增菜单',
           editMenu: '编辑菜单',
        },
        video: {
            name: '名称',
            type: '类型',
            address: '视频点位置',
            source: '视频源/编码',
            station: '站点',
            control: '云台控制',
            placeholder_name: '请输入名称',
            placeholder_type: '请选择类型',
            placeholder_source: '请输入视频源',
            placeholder_address: '请输入视频点位置',
            formatLength: '长度2~16',
            formatType: '请选择类型',
            formatSource: '请输入视频源/编码',
            formatSource1: '长度不能超过200个字符',
            formatAddress: '长度不能超过250个字符',
            addVideo: '新增视频点',
            editVideo: '编辑视频点',
            platform: '平台接入'
        },
        device: {
            placeholder: '请输入账号/设备码...',
            account: '账号',
            code: '设备码',
            type: '设备类型',
            createTime: '申请时间',
            auditStatus: '审核状态',
            audit: '审核',
            auditConfirm: '确定要审核吗',
            pc: 'PC端',
            mobile: '移动端',
            audited: '已审核',
            unaudit: '未审核',
            deleteConfirm: '确认要删除设备码'
        },
        auth: {
            name: '名称',
            role: '角色',
            menu: '菜单',
            addRole: '新增角色',
            roleDeleteFail: '角色{name}删除失败(请先删除子权限)',
            roleDeleteFail1: '角色{name}删除失败',
            enterRole: '请输入角色名',
            length: '长度2~16',
            selectRole: '请选择一个角色',
            selectRole1: '请选择角色',
            RoleExistError: '角色{newRole}已经存在',
            RoleAddError: '角色{newRole}新建失败',
            RoleAddSuccess: '角色{newRole}新建失败',
            confirmClearRole: '确定要清空角色[{name}]的菜单吗',
            roleDistributionSuccess: '角色{name}的菜单分配成功',
            roleDistributionFail: '角色{name}的菜单分配失败',
            roleSteSuccess: '角色{name}创建成功',
            
        },
        
    },
    //数据监测-运行监控
    operation: {
        factory: '厂站',
        group: '分组',
        factoryName: '厂名',
        groupName: '组名',
        name: '遥测名',
        value: '遥测值',
        time: '遥测时间',
        placeholder: '遥测名...'
    },
    //历史数据
    history: {
        factory: '厂站',
        group: '分组',
        point: '点号',
        searchType: '查询类型',
        integer: '整点',
        original: '原始',
        placeholder_point: '请选择点号',
        tips_point: '请选择点号！',
        tips_time: '请选择时间区间！',
        tips_time1: '开始时间不能大于结束时间！',
        tips_time2: '开始时间与结束时间相差不能超过一个月！',
        type: '类型',
        eventContent: '事件内容',
        warnType: '告警类型',
        status: '状态',
        value: '动作值',
        all: '全部',
        default: '默认',
        system: '系统',
        alarm: '报警',
        accident: '事故',
        operator: '操作',
        telemetry_limit: '遥测越限',
        telemetry_displacement: '遥信变位',
        register_info: '注册信息',
        info_tips: '信息提示',
        equipment_inspect: '设备巡检',
        operator_record: '操作记录',
        spare: '备用',
        undefine: '未定义'
    },
    //统计分析
    analysis: {
        factory: '厂站',
        group: '分组',
        point: '点号', 
        showModel: '显示方式',
        dimension: '维度',
        statisticsType: '统计类型',
        tips_point: '请选择点号！',
        tips_time: '请选择时间区间！',
        tips_time1: '开始时间不能大于结束时间！',
        tips_time2: '开始时间与结束时间相差不能超过一个月！',
        tips_time3: '开始时间与结束时间相差不能超过一年！',
        tips_time4: '开始时间与结束时间相差不能超过十年！',
        year: '年',
        month: '月',
        day: '日',
        hour: '时',
        single: '单图',
        multi: '多图',
        avg: '平均值',
        max: '最大值',
        min: '最小值',
        compareTime: '同比时间'
    }
}

export default Object.assign({}, index, i18n)


// WEBPACK FOOTER //
// ./src/i18n/langs/zh/index.js